<template>
  
    <div class="container-fluid" id="Home">
      <center>
        <h1 class="text-center text-white">{{filterTitle()}}</h1>
      </center>
      <br />
      <QuestionsList :questionList="$store.getters.getQasFiltered" :filter="$route.params.filter" />
    </div>
  
</template>

<script>
import QuestionsList from "./../components/questions/QuestionsList.vue";


export default {
  name: "Home",
  components: {
    QuestionsList
  },
  methods: {
    filterTitle(){
      let filters = [];
      const categoryFilter = this.$store.getters.getCategoryFilter;
      const subcategoryFilter = this.$store.getters.getSubCategoryFilter;
      categoryFilter ? filters.push( categoryFilter ) : null;
      subcategoryFilter ? filters.push( subcategoryFilter ) : null;
      return filters.join(' - ')
    }
  },
  data() {
    return {
      tittle: "Home"
    };
  },  
};
</script>

<style>
#Home {
  /*display: flexbox;*/
  background-color: #49a1a1;
  min-height: 100vh;
  width: 100%;
  height: 100%; 
}
#workspace {
  /*display: flexbox;*/
  width: 100%;
  height: 100%;  
}
</style>